import { render, staticRenderFns } from "./MiniQuestionPallet.vue?vue&type=template&id=dd634372&"
import script from "./MiniQuestionPallet.vue?vue&type=script&lang=js&"
export * from "./MiniQuestionPallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports